import React, { FC } from 'react';

import { useComponentSearchFilters } from 'components/component-overview/hooks/use-component-search-filters';
import { SearchService } from 'components/component-overview/services/SearchService';
import { InlineFiltersManufacturerComponent } from 'components/inline-filters/InlineFilters.Manufacturers';

type Props = {
    isViewOnly?: boolean;
    isRequired?: boolean;
    onSelectOptional?: (id: string) => void;
};

const InlineFiltersManufacturer: FC<Props> = ({ isViewOnly, isRequired, onSelectOptional }) => {
    const { manufacturer: selectedManufacturerId } = useComponentSearchFilters();

    const onSelect = (id: string) => {
        SearchService.setFilter('manufacturer', id);
        if (onSelectOptional) onSelectOptional(id);
    };

    const onRemove = () => {
        SearchService.setFilter('manufacturer', undefined);
    };

    return (
        <InlineFiltersManufacturerComponent
            isViewOnly={isViewOnly}
            isRequired={isRequired}
            onSelect={onSelect}
            onRemove={onRemove}
            selectedManufacturerIds={selectedManufacturerId}
        />
    );
};

export { InlineFiltersManufacturer };
